<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3
      class="sp-color__accent"
      [innerHTML]="'PRODUCT_CATEGORY.UPDATE_STEPS_TITLE' | translate : { name: category?.name }"></h3>
    <form
      [formGroup]="product_category_update_steps_from_group"
      class="sp-margin__top-x2">
      <div
        formArrayName="installment_plans"
        class="sp-column">
        <div
          *ngFor="let plan of getInstallmentPlans().controls; let i = index"
          [formGroupName]="i"
          class="sp-row__align sp-margin__bottom-x2">
          <span
            class="sp-color__primary sp-text__bold"
            style="min-width: 80px">
            {{ plan.get('plan_length')?.value }} rate
          </span>
          <mat-form-field
            class="sp-width__full sp-form-field sp-margin__bottom-x2"
            [ngClass]="getStepZeroMaxPercFormFieldErrorClass('step_0_tax_percentage', i)"
            appearance="fill"
            color="accent">
            <mat-label>{{ 'PRODUCT_CATEGORY.ZERO_RATE_PERCENTAGE_LABEL' | translate }}</mat-label>
            <input
              matInput
              type="number"
              step="0.01"
              formControlName="step_0_tax_percentage"
              [errorStateMatcher]="error_matcher"
              placeholder="0.00"
              required />
            <span matSuffix>%</span>
            <mat-error *ngIf="hasStepZeroMaxPercError('step_0_tax_percentage', i)">
              {{ 'ERROR.STEP_ZERO_PERCENTAGE_ERROR' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Confirm Button -->
      <app-shared-button
        class="sp-width__full sp-margin__top"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="is_submit_running"
        [is_spinner_visible]="is_submit_running"
        (click)="onSubmitClick()"></app-shared-button>
    </form>
  </div>
</div>
